import React from 'react';
import TraderSelectField from 'components/TraderSelectField';
import GradeSelectFilter from 'components/GradeSelectFilter';
import CityFieldFilter from 'components/CityFieldFilter';
// import OrderSelectStatusFilter from '../OrderSelectStatusFilter';

const OrderFilter = () => {
  const gradeFilter = {
    key: 'status',
    value: 'ALL',
    type: 'STRING',
    op: 'EQ',
  };
  const traderFilter = {
    key: 'kycStatus',
    value: 'ALL',
    type: 'STRING',
    op: 'EQ',
  };
  return (
    <>
      <TraderSelectField
        name="seller"
        label="Seller"
        keysName="entityName"
        statusFilter={traderFilter}
      />{' '}
      <GradeSelectFilter
        name="grade"
        label="Grade"
        statusFilter={gradeFilter}
      />
      <TraderSelectField
        name="buyer"
        label="Buyer"
        keysName="entityName"
        statusFilter={traderFilter}
      />
      {/* <OrderSelectStatusFilter label="Select Status" name="status" /> */}
      <CityFieldFilter label="City" name="cityName" />
    </>
  );
};

export default OrderFilter;
